import { CallInfo, Constants } from '@salesforce/scv-connector-base';

export class CallInfoGenerator {
  static generate(callId: string): CallInfo {
    return new CallInfo({
      isMuted: false,
      isOnHold: false,
      isRecordingPaused: true,
      initialCallId: callId,
      isSoftphoneCall: true,
      acceptEnabled: true,
      declineEnabled: true,
      muteEnabled: true,
      swapEnabled: true,
      conferenceEnabled: true,
      holdEnabled: true,
      recordEnabled: true,
      addCallerEnabled: true,
      extensionEnabled: true,
      isReplayable: true,
      isBargeable: false,
      isExternalTransfer: false,
      removeParticipantVariant: Constants.REMOVE_PARTICIPANT_VARIANT.ALWAYS,
    });
  }

  static generateWithRecordingCapabilities(
    callId: string,
    isRecordingPaused: boolean,
    recordEnabled: boolean,
  ): CallInfo {
    const callInfo = CallInfoGenerator.generate(callId);
    callInfo.isRecordingPaused = isRecordingPaused;
    callInfo.recordEnabled = recordEnabled;
    return callInfo;
  }
}
